import { defineMessages } from 'react-intl';

export default defineMessages({
  TableNavigationShowingCountOfTotal: {
    id: 'TableNavigationShowingCountOfTotal',
    defaultMessage: 'Showing {from}-{to} of {total}',
  },
});
